import React from 'react';

export default function ComponentsPage() {
  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">UI Components</h1>
      <p className="text-gray-600 mb-6">Embeddable React auth components (<code>@authaas/auth-components</code>) — drop a hosted login/signup UI into your app.</p>

      <div className="bg-white border border-gray-200 rounded-lg p-5 mb-4">
        <h2 className="font-semibold mb-2">Install</h2>
        <pre className="bg-gray-900 text-gray-100 rounded p-3 text-sm">npm install @authaas/auth-components</pre>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-5">
        <h2 className="font-semibold mb-2">Usage</h2>
        <pre className="bg-gray-900 text-gray-100 rounded p-3 text-sm overflow-auto">{`import { LoginForm, SignupForm } from "@authaas/auth-components";

import { AuthProvider, SignInForm } from "@authaas/auth-components";

export default function Auth() {
  // That's it — the publishable key is the only value you need. Branding,
  // enabled methods, and password rules are fetched automatically.
  return (
    <AuthProvider publishableKey="pk_live_...">
      <SignInForm onSuccess={() => { /* you're signed in */ }} />
    </AuthProvider>
  );
}`}</pre>
        <p className="text-xs text-gray-500 mt-3">The publishable key is auto-attached to sign-in/sign-up so users are attributed to your organization with your configured policies — no other config required.</p>
      </div>
    </div>
  );
}
